/* eslint-disable no-nested-ternary */
import React from 'react'

import PropTypes from 'prop-types'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import CategoryListSkeleton from '../CategoryList/CategoryListSkeleton'
import ProductCardGroup from '../ProductGroupCard/ProductGroupCard'
import { CHUNK_SIZE, chunkArray } from '../../helpers/AvailabilityHelper'

const ProductList = props => {
  const { destinationPageType, products, showLoader } = props
  const groupedProducts = chunkArray(products, CHUNK_SIZE)

  return (
    <ErrorBoundary>
      <div data-test='product-list'>
        {showLoader && destinationPageType === 'CLP' ? (
          <CategoryListSkeleton isFullSize />
        ) : (
          groupedProducts.map((chunkProduct, groupIndex) => {
            return <ProductCardGroup chunkProduct={chunkProduct} groupIndex={groupIndex} {...props} key={groupIndex} />
          })
        )}
      </div>
    </ErrorBoundary>
  )
}

ProductList.propTypes = {
  destinationPageType: PropTypes.string,
  products: PropTypes.array.isRequired,
  showLoader: PropTypes.bool
}

ProductList.defaultProps = {
  destinationPageType: '',
  showLoader: false
}

export default ProductList
